import React, { useEffect, useRef, useParams } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Tag } from "primereact/tag";
import { getVcompNotifications } from "../../../containers/dashboard/dashboardSlice";
import { Localize } from "../../../app/lang/langs";
import styles from "../Dashboard.module.css";
import { useNavigate } from "react-router-dom";

export default function VcompParticipateNotification() {
    const dispatch = useDispatch();
    const mounted = useRef(false);
    const navigate = useNavigate();
    const vcompParticipateNotification = useSelector(
        (state) => state.dashboard.vcompParticipateNotification
    );
    const selectedTeamsIds = useSelector((state) => state.teams.selectedTeamsIds)

    useEffect(() => {
        if (!mounted.current) {
            dispatch(getVcompNotifications());
            mounted.current = true;
        }
    }, [mounted]);

    const navToVcompProject = (rowData) => {
        const encodedLabel = encodeURIComponent(rowData.project_name);
        navigate(`/vcomp/${selectedTeamsIds[0]}/0/${encodedLabel}`);
        //setSelectedTeams([rowData.id_team])
    }

    const answeredBody = (row) => {
        const isAnswered =
            row.answered === true || row.answered === 1 || row.answered === "1";
        return (
            <Tag
                value={isAnswered ? (Localize("ANSWERED") || "Answered") : (Localize("PENDING") || "Pending")}
                icon={isAnswered ? "pi pi-check-circle" : "pi pi-clock"}
                severity={isAnswered ? "success" : "warning"}
                rounded
                className={styles.tagHov}
                onClick={() => { if (!isAnswered) navToVcompProject(row) }}
            />
        );
    };

    const mcqBody = (row) => {
        const hasMcq =
            row.active_mcq === "1" || row.active_mcq === 1 || row.active_mcq === true;
        return (
            <Tag
                value={hasMcq ? (Localize("MCQ_ACTIVE") || "MCQ") : (Localize("NONE") || "None")}
                icon={hasMcq ? "pi pi-list-check" : "pi pi-minus"}
                severity={hasMcq ? "info" : "secondary"}
                rounded
                className={styles.tag}
            />
        );
    };

    const startDateBody = (row) => (
        <div className={styles.cellWithIcon}>
            <i className="pi pi-calendar" />
            <span>{row.start_date_raw || "-"}</span>
        </div>
    );

    const sessionBody = (row) => (
        <Tag
            value={`S${row.session_number ?? "-"}`}
            severity="secondary"
            rounded
            className={styles.tag}
        />
    );

    const rowClassName = (row) => {
        const isAnswered =
            row.answered === true || row.answered === 1 || row.answered === "1";
        return isAnswered ? "" : styles.rowUnanswered;
    };

    return (
        <div className={styles.vcompCard}>
            <DataTable
                value={vcompParticipateNotification}
                scrollable
                scrollHeight="350px"
                size="small"
                stripedRows
                rowHover
                showGridlines
                emptyMessage={Localize("NO_NOTIFICATIONS") || "No notifications"}
                rowClassName={rowClassName}
                className="p-datatable-sm"
                header={Localize("MY_VCOMP_PROJECTS") || "Vcomp Participate Notifications"}
            >
                <Column
                    field="project_name"
                    header={Localize("PROJECT_NAME")}
                    style={{ minWidth: "18rem" }}
                />
                <Column
                    field="answered"
                    header={Localize("ANSWERED")}
                    body={answeredBody}
                    style={{ width: "10rem" }}
                />
                <Column
                    field="active_mcq"
                    header={Localize("MCQ_ACTIVE")}
                    body={mcqBody}
                    style={{ width: "10rem" }}
                />
                <Column
                    field="start_date_raw"
                    header={Localize("SESSION_START_DATE")}
                    body={startDateBody}
                    style={{ minWidth: "12rem" }}
                />
                <Column
                    field="session_number"
                    header={Localize("SESSION_NUMBER") || "SESSION_NUMBER"}
                    body={sessionBody}
                    style={{ width: "8rem" }}
                />
            </DataTable>
        </div>
    );
}
